import React, { useState, useEffect } from "react";
import "./ForgotPasswordForm.css";
import Logo from "../../assets/images/logo/logo1.svg";
import { ToastContainer } from "react-toastify";
import { showToast } from "../utils/Function/Helper";
import { sendOTP, verifyOTP, changePassword } from "../../services/api/api";
import { useDispatch } from "react-redux";
import { setUserDetails } from "../../redux/slice/user";
import EmailField from "./EmailField";
import ChangePasswordField from "./ChangePasswordField";
import OTPField from "./OTPField";




const ForgotPasswordForm = () => {

  const dispatch = useDispatch();

  useEffect(() => {


    console.log("working");
    
    localStorage.removeItem("sessionId");
    dispatch(setUserDetails({ loggedin: "no", userDetails: {} }));
  }, [dispatch]);  


  const [step, setStep] = useState("email"); 
  const [formValues, setFormValues] = useState(
    { email: "",
      otp: "",
      password: "",
      re_password:""
    });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [btnDisable, setBtnDisable] = useState(false);

  const logoutSuccess = localStorage.getItem("logoutSuccess");

  useEffect(() => {
    if (logoutSuccess) {
      showToast("error", logoutSuccess);
      setTimeout(() => {
        localStorage.removeItem("logoutSuccess");
      }, 500);
    }
  }, [logoutSuccess]);

  const handleSubmit = async (e) => {
    
  

    e.preventDefault();
    console.log(errors);
    console.log(step);

    if (validate()) {
      console.log("validated");
      
      setLoading(true); 

      
      try {
        
        if (step === "email") {
          console.log("api");

          const response = await sendOTP(formValues);        
          setLoading(false);

          if (response.trim() == "Success"){
            setStep("otp");
            showToast("success", "OTP sent to your email");
          }else{
            showToast("error", response.trim());
          }
           

        } else if (step === "otp") {
          const response = await verifyOTP(formValues);
          setLoading(false);

          if (response.trim() == "Success"){
            setStep("changePassword");
            showToast("success", "OTP verified Successfully");
          }else{
            showToast("error", response.trim());
          }
           


        } else if (step === "changePassword") {

          
          const response = await changePassword(formValues);

          if (response.trim() == "Success"){
     
            showToast("success", "Password changed Successfully");

            setTimeout(() => {
              window.location.href = "/login";
          }, 2000); //2000ms = 2 seconds
          }else{
            showToast("error", response.trim());
          }

          // if (response.status) window.location.href = "/"; // Redirect after success
        }
      } catch (error) {
        setErrors({ [step]: error.message }); // Show error for the current step
      }
    }
  };




  const handleChange = (e) => {
    const { name, value } = e.target;
  
    // Update form values
    setFormValues((prevValues) => ({ ...prevValues, [name]: value }));
  
    // Remove error for the current field
    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors[name]; // Remove error for the specific field
      return newErrors;
    });
  };
  

  console.log(errors);
  console.log(formValues);

  
  const validate = () => {
    let newErrors = {};
  
    if (step === "email") {
      if (!formValues.email) newErrors.email = "Email is required";
      else if (!/\S+@\S+\.\S+/.test(formValues.email)) newErrors.email = "Please enter a valid email";
    } else if (step === "otp") {
      if (!formValues.otp) newErrors.otp = "OTP is required";
    } else if (step === "changePassword") {
      if (!formValues.password ) {
        newErrors.password = "Please enter your password";
      }else if(!formValues.re_password){
        newErrors.re_password = "Please enter your password again !";
      }
      
      
      if(formValues.password !== formValues.re_password){
        newErrors.re_password = "Password not matching !";
      }
    }
  
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors); // Update errors if there are any
      return false; // Validation failed
    }
  
    return true; // Validation passed
  };





  return (
    <>
      <div>
        <ToastContainer />
        <div className="container-fluid d-flex justify-content-center align-items-center login-container">
          <div className="card my-5 login-wrapper bg-light">
          {step === "email" && <EmailField handleSubmit={handleSubmit} handleChange={handleChange} formValues={formValues} errors={errors} Logo={Logo} loading={loading}/>}
          {step === "otp" && <OTPField  handleSubmit={handleSubmit} handleChange={handleChange} formValues={formValues} errors={errors} Logo={Logo} loading={loading}/>}

{step === "changePassword" &&  <ChangePasswordField  handleSubmit={handleSubmit} handleChange={handleChange} formValues={formValues} errors={errors} Logo={Logo} loading={loading}/>}



          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPasswordForm;
